// Fixed user-facing wording that has legal or privacy weight. Kept in one place so the
// components and the solicitor review pack (T24, `npm run pack:solicitor`) use the same text.

export const DISCLAIMER = {
  lead: 'ShiftLens provides guidance, not legal advice.',
  body: "It checks your rota against the Working Time Regulations, but it can't see everything about your business, such as contracts, agreements or the hours people actually worked. For advice on your situation, contact Acas or an employment solicitor.",
};

export const PRIVACY_NOTE = {
  lead: 'Your rota stays on this device.',
  body: 'We checked it in your browser. Nothing about your staff has been sent anywhere.',
  detailsTitle: 'How this works',
  details:
    "ShiftLens reads your file and runs every check inside your web browser, on your own computer or phone. Your staff names, shifts and dates are never uploaded to us or anyone else, and they're gone when you close this page. There's no sign-up, and we don't ask for your email. The page only tells our own server that a rota was checked, with nothing from the rota itself.",
};
